module.exports = __webpack_public_path__ + "cancellara-dist/img/chi_siamo_header.e1067597.jpg";